module.exports = __webpack_public_path__ + "static/media/06.aea59053.mp3";